import { TotalFollowers } from "@/modules/total-followers";
import { TotalIncome } from "@/modules/total-income";
import { CurrentBalance } from "@/modules/current-balance";

export function StatCardsRow() {
  return (
    <div className="col-span-full grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
      <TotalFollowers />
      <TotalIncome />
      <CurrentBalance />
    </div>
  );
}
